import React, { useState, useEffect, useRef } from "react";
import { Container, Col, FormGroup, Label, Input } from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import { Loading } from '../share/loading'
import { useSearchParams, useNavigate } from "react-router-dom";
import { NumberWithCommas } from '../share/NumberWithCommas'
import * as Yup from 'yup'
import '../share/form.css';
import Select from "react-select";
import Swal from 'sweetalert2'
import { GetVMdDept } from "../share/api/MasterDataApi";
import { FormikSelect } from "../share/FormikSelect";
// import { NumericFormat } from 'react-number-format';
// import DataRegisterComponent from "../../share/DataRegisterComponent";
import { ReplaceNullWithEmptyString } from "../share/ReplaceNullWithEmptyString";
import { FaSistrix } from "react-icons/fa";

export function CreateSupportAnnounce6Component() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const formikRef = useRef(null); // ✅ ใช้ useRef เพื่อดึง setFieldValue ภายนอก

    let supportId = searchParams.get("req");
    let supportTypeId = searchParams.get("type");
    const [currentSupportForm, setCurrentSupportForm] = useState(null);
    const [listregisterOptions, setListRegisterOptions] = useState([]);
    const [selectRegisterId, setSelectRegisterId] = useState(0);

    // console.log("currentSupportForm", currentSupportForm);
    const [loading, setLoading] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    const [userAuthRegister, setUserAuthRegister] = useState([]);
    // console.log("userProfile", userProfile);
    const [calculateLoading, setCalculateLoading] = useState(false)
    const [checkLoading, setCheckLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem("userData"))

    let getYear = new Date().getFullYear();
    const [dataAnnounce6, setDataAnnounce6] = useState([]);
    // console.log("dataAnnounce6", dataAnnounce6);
    const [deptsData, setDeptsData] = useState([]);
    // const [titleName, setTitleName] = useState([]);

    const [conditionOne, setConditionOne] = useState(null);
    // console.log("conditionOne", conditionOne);
    const [calculateAmount, setCalculateAmount] = useState(0);
    // console.log(calculateAmount, "calculateAmount");
    useEffect(() => {
        GetVMdDept({ setDeptsData, setLoading })
        // GetTitleName()
        checkDataAnnounce6()
        getProfile();
    }, [])

    useEffect(() => {
        getProfile();
        checkDataAnnounce6()
    }, [selectRegisterId])

    useEffect(() => {
        const GetListRegister = async () => {
            try {
                const res = await fetch("/api/OfficerBorrowing/listRegister", {
                    method: "GET",
                    headers: { 'token': user.token },
                })
                const resJson = await res.json();
                setListRegisterOptions(resJson.dataenum);
            } catch (e) {
                // console.log("err", e)
            }
        }
        GetListRegister();
    }, [])


    // สมมติ data มาจาก API
    const registerOptions = (listregisterOptions || []).map((x) => ({
        value: x.registerId, // เก็บค่า registerId
        // label: `${x.companyNo ?? "-"} | ${x.customerNo ?? "-"} | ${x.fullName ?? "-"}`,
        label: `${x.fullName ?? "-"}`,

        companyNo: x.companyNo ?? "",
        customerNo: x.customerNo ?? "",
        fullName: x.fullName ?? "",
    }));
    const toText = (v) => (v ?? "").toString().toLowerCase();

    const customFilter = (option, rawInput) => {
        const q = toText(rawInput);
        const d = option && option.data ? option.data : {};
        return [d.companyNo, d.customerNo, d.fullName].some((f) => toText(f).includes(q));
    };

    const getProfile = async () => {
        try {
            let formData = new FormData();
            formData.append("registerId", selectRegisterId ?? 0)

            const res = await fetch("/api/Profile/getProfile", {
                method: "POST",
                headers: { 'token': user.token },
                body: formData
            })
            const resJson = await res.json();

            resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
            setUserProfile(resJson.dataenum);
            setUserAuthRegister(resJson.dataenum.authRegister);
            if (supportId == "0") {
                // ✅ ใช้ setFieldValue ผ่าน formikRef
                formikRef.current?.setFieldValue("deptId", resJson.dataenum.deptId);
                formikRef.current?.setFieldValue("coordinateName", resJson.dataenum.contactorName);
                formikRef.current?.setFieldValue("coordinatePhone", resJson.dataenum.contactorPhone);
                formikRef.current?.setFieldValue("coordinateMobile", resJson.dataenum.phone);
                formikRef.current?.setFieldValue("coordinateFax", resJson.dataenum.fax);
                formikRef.current?.setFieldValue("coordinateEmail", resJson.dataenum.email);
            }

        } catch (e) {
            // console.log("err", e)
        }
    };

    useEffect(() => {
        async function calculateAmountSupport() {
            setCalculateLoading(true)
            try {
                // dataAnnounce6.map((data) => {
                //     setCalculateAmount(data.more70 * Number(conditionOne))
                // })
                setCalculateAmount(dataAnnounce6[0]?.amount);
            } catch (e) {
                // console.log(e)
            } finally {
                setCalculateLoading(false)
            }

        }
        calculateAmountSupport();
    }, [dataAnnounce6, conditionOne])

    useEffect(() => {
        const GetCurrentSupportForm = async () => {
            if (supportId !== "0") {
                let postData = new FormData();
                postData.append("supportId", Number(supportId));
                postData.append("supportTypeId", Number(supportTypeId));
                setLoading(true);
                try {
                    let res = await fetch("/api/SupportForm/getSupportFormData", {
                        method: "POST",
                        body: postData
                    })
                    let resJson = await res.json();
                    if (resJson.status == 1) {
                        resJson.dataenum["customerTypeId"] = Number(user.roldId);
                        resJson.dataenum["registerId"] = Number(user.registerId);
                        resJson.dataenum["announce"] = "6";
                        resJson.dataenum["term"] = true;
                        // setCalculateAmount(resJson.dataenum.amount);
                        setCurrentSupportForm(ReplaceNullWithEmptyString(resJson.dataenum));
                    }

                } catch (e) {
                    // console.log("err", e);
                } finally {
                    setLoading(false);
                }
            } else {
                return;
            }
        };
        GetCurrentSupportForm();
    }, [])


    useEffect(() => {

        const getCondition = async () => {
            setCheckLoading(true)
            // let id = 5;
            try {
                let res = await fetch(`api/SupportForm/getConditionSupport/${5}`)
                let resJson = await res.json();
                // console.log(resJson.dataenum);
                // setConditionData(resJson.dataenum);

                resJson.dataenum?.map((condition) => {
                    setConditionOne(condition.condition1);
                    // setConditionTwo(condition.condition2);
                    // setConditionDate(condition.conditionDate);
                })

            } catch (e) {
                // console.log('err => ', e)
            } finally {
                setCheckLoading(false)
            }
        }
        getCondition();
    }, [])



    async function checkDataAnnounce6() {
        setCheckLoading(true)
        if (selectRegisterId == 0) {
            return
        }
        let postData = new FormData()
        postData.append("registerId", selectRegisterId ?? 0)
        try {
            let res = await fetch(`api/SupportForm/checkAnnounce6`, {
                method: "POST",
                body: postData
            })
            let resJson = await res.json();
            // console.log("resJson.dataenum", resJson.dataenum)
            if (resJson.status === 1) {
                if (resJson.dataenum.length > 0) {
                    setDataAnnounce6(resJson.dataenum)
                } else {
                    Swal.fire({
                        icon: "info",
                        title: "คุณไม่มีสิทธิ์ขอรับเงินช่วยเหลือหรืออุดหนุน ตามประกาศ 6",
                        text: "โปรดตรวจสอบข้อมูลอีกครั้ง",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    })
                        .then((result) => {
                            if (result.isConfirmed) {
                                // navigate("/supporting/")
                            }
                        })
                }
            } else {
                let startDate = new Date(getYear, 3, 1);
                let endDate = new Date(getYear, 5, 29);
                if (startDate < new Date() && new Date() < endDate) {
                    Swal.fire({
                        icon: "info",
                        title: "คุณไม่มีสิทธิ์ขอรับเงินช่วยเหลือหรืออุดหนุน ตามประกาศ 6",
                        text: "โปรดตรวจสอบข้อมูลอีกครั้ง",
                        confirmButtonColor: "#0A66C2",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // navigate("/supporting/")
                        }
                    })
                }
            }
        } catch (e) {
            // console.log("err", e)
        } finally {
            setCheckLoading(false)
        }
    }

    //function เปิด-ปิดช่วงเวลาการขอรับเงินช่วยเหลือหรืออุดหนุน
    // useEffect(() => {
    //     if (supportId == "0") {
    //         let startDate = new Date(getYear, 3, 1);
    //         let endDate = new Date(getYear, 5, 29);
    //         if (new Date() < startDate || new Date() > endDate) {
    //             // console.log("is valid")
    //             Swal.fire({
    //                 icon: "info",
    //                 html: `สามารถขอเงินช่วยเหลือหรืออุดหนุนได้ <br/> ภายใน 1 เมษายน ${getYear} ถึง 29 มิถุนายน ${getYear}`,
    //                 text: "",
    //                 confirmButtonColor: "#0A66C2",
    //                 confirmButtonText: "ตกลง",
    //                 allowOutsideClick: false,
    //                 allowEscapeKey: false,
    //             }).then((result) => {
    //                 if (result.isConfirmed) {
    //                     navigate("/supporting/")
    //                 }
    //             })
    //         }
    //     }


    // }, [searchParams])

    // ดึง master data หน่วยงานกรมพัฒฯ


    // async function GetTitleName() {
    //     const res = await fetch("/api/MasterData/getTitle")
    //     const data = await res.json()
    //     setTitleName(data.dataenum);
    // }

    const authRegisterOptions = userAuthRegister?.map((item) => ({
        label: item.authFullName,
        value: item.authRegisterId
    })) || [];

    const initialValues = {
        supportId: "0",
        registerId: Number(user.registerId),
        announce: "6",
        supportTypeId: "5",
        deptId: "",
        authRegisterId: 0,
        customerTypeId: Number(user.roldId),
        employeeAmount: "",
        amount: calculateAmount,
        paymentName: "",
        fOtherPath: "",
        term: "",

    }

    const onSubmit = async (values) => {

        Swal.fire({
            icon: "warning",
            title: "ยืนยันการบันทึกข้อมูลหรือไม่ ?",
            // text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            showCancelButton: true,
            cancelButtonText: 'ยกเลิก',
            cancelButtonColor: "#ff00000"
        }).then(async (result) => {
            if (result.isConfirmed) {
                let postData = new FormData();

                Object.entries(values).forEach(([key, value]) => {
                    if (key.endsWith("amount")) {
                        postData.append("amount", calculateAmount)
                        // postData.append(key, Number(value).toFixed())
                    } else {
                        postData.append(key, value);
                    }
                });
                // console.log(postData);

                try {
                    let res = await fetch("/api/SupportForm/saveSupportForm", {
                        method: "POST",
                        body: postData
                    });

                    let resJson = await res.json();
                    // console.log(resJson.dataenum);

                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/supporting/")
                            }
                        })
                    } else if (resJson.status === 4) {
                        Swal.fire({
                            icon: "warning",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (e) {
                    // console.log(e)
                }
            }
        })
        // setFieldValue(values.amount,calculateAmount)


    }

    const validationSchema = Yup.object().shape({
        deptId: Yup.string()
            .required("กรุณาเลือกหน่วยงานที่ยื่นคำขอ"),
        employeeAmount: Yup.number()
            .typeError("จำนวนลูกจ้างต้องเป็นตัวเลขเท่านั้น")
            .required("กรุณากรอกจำนวนลูกจ้าง"), //จำนวนลูกจ้าง
        paymentName: Yup.string().required("กรุณากรอกชื่อผู้ขอรับเงิน"),
        fOtherPath: Yup.mixed().when('file', {
            is: value => value !== undefined && value !== null && value !== "",
            then: Yup.mixed()
                .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
                    return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
                })
                .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 25MB', value => {
                    const maxSize = 25000000;
                    return !value || value.size <= maxSize;
                }),
        }),
        term: Yup.bool()
            .oneOf([true], "กรุณายอมรับข้อตกลง"),
    })


    useEffect(() => {
        if (supportId == "0") {
            formikRef?.current?.setFieldValue("year1", dataAnnounce6[0]?.receiveYear?.toString());
        }
    }, [dataAnnounce6])

    return (
        <Formik
            innerRef={formikRef} // ✅ ตรงนี้สำคัญ
            initialValues={supportId === "0" ? initialValues : currentSupportForm}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={supportId == "0" ? false : true}
        >
            {({ setFieldValue, values, touched, errors, handleBlur, handleChange }) => {
                // console.log("values",values);
                const findPersonalId = () => {
                    if (values.authRegisterId != 0) {
                        const found = userAuthRegister.find(item => item.authRegisterId == values.authRegisterId);
                        return found.authPersonalId
                    }
                }
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading && !checkLoading ? (
                            <div className="form-border">

                                <Form className='p-5 mb-4'>

                                    <Label
                                        style={{ fontWeight: "bold" }}
                                        className='customer-type text-center px-5'
                                    >
                                        คำขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545
                                        กรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน
                                    </Label>
                                    <FormGroup className="mb-3">
                                        <Label htmlFor="establishmentId" className="fw-semibold">
                                            เลือกผู้ใช้งานที่จะลงทะเบียนให้ <span className="require-input">*</span>
                                        </Label>

                                        <Select
                                            options={registerOptions}
                                            filterOption={customFilter}
                                            placeholder="ค้นหาโดย เลขทะเบียนนิติบุคคล 13 หลัก, เลขสถานประกอบการ 10 หลัก หรือ ชื่อสถานประกอบการ"
                                            isClearable
                                            noOptionsMessage={() => "ไม่พบข้อมูล"}
                                            onChange={(selected) => {
                                                // console.log("selected.value", selected.value);
                                                // selected = { value, label, companyNo, customerNo, fullName }
                                                setSelectRegisterId(selected.value)
                                                setFieldValue("registerId", selected ? selected.value : "");
                                            }}
                                            value={registerOptions.find(item => item.value == selectRegisterId)}
                                        />
                                    </FormGroup>
                                    {/* ปุ่มลงทะเบียนใหม่ */}
                                    {/* <div className="d-flex align-items-center mt-2">
                                        <span className="me-3 text-muted">
                                            หากยังไม่ได้ลงทะเบียนสถานประกอบการในระบบ
                                        </span>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary rounded-pill px-4"
                                            onClick={() => navigate("/register-establishment")} // 🔧 route ปรับตามจริง
                                        >
                                            ลงทะเบียน
                                        </button>
                                    </div> */}
                                    {/* ดึงข้อมูลมาแสดง */}
                                    <Label className="mb-3 input-color">ข้อมูลผู้ขอเงินช่วยเหลือหรืออุดหนุน</Label>
                                    {/* <DataRegisterComponent /> */}
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน

                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.entrepreneurName ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            เลขทะเบียนนิติบุคคล
                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.customerNo ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ประเภทกิจการ
                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.businessType ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>

                                    {/* input เลือกหน่วยงานที่จะยื่นคำขอ */}
                                    <FormGroup className="mt-3">
                                        <Label
                                            for="dept">
                                            ยื่นคำขอที่
                                            <span className="require-input">*</span>
                                            {touched.deptId && errors.deptId ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.deptId}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>

                                            <Field
                                                name="deptId"
                                                component={FormikSelect}
                                                options={deptsData}
                                                placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                            />
                                        </Col>
                                    </FormGroup>



                                    {/* ผู้กระทำการแทน คำนำหน้าและชื่อ */}
                                    <FormGroup row>
                                        <Label
                                            for="titleId">
                                            โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ)
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.authRegisterId &&
                                                errors.authRegisterId ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.authRegisterId}
                                                </span>
                                            ) : null}

                                        </Label>

                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Field
                                                    name="authRegisterId"
                                                    component={FormikSelect}
                                                    options={authRegisterOptions}
                                                    placeholder={<div className="input-color text-center">กรุณาเลือก</div>}
                                                />
                                            </div>

                                        </div>

                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="titleId">
                                            เลขบัตรประจำตัวประชาชน

                                        </Label>

                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Input
                                                    className="rounded-pill text-center input-color"
                                                    type="text"
                                                    name=""
                                                    id=""
                                                    disabled
                                                    value={findPersonalId()}
                                                />

                                            </div>
                                        </div>
                                    </FormGroup>

                                    {/* ประกอบกิจการประเภท และ จำนวนลูกจ้าง */}
                                    <FormGroup className=''>
                                        <Label
                                            for="employeeAmount">จำนวนลูกจ้าง
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.employeeAmount && errors.employeeAmount ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.employeeAmount}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className={touched.employeeAmount && errors.employeeAmount ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="employeeAmount"
                                                id="employeeAmount"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={values?.employeeAmount}
                                            />
                                        </Col>
                                    </FormGroup>

                                    {/* ชื่อผู้ประสานงาน */}
                                    <FormGroup>
                                        <Label
                                            for="contact">ชื่อผู้ประสานงาน
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {/* {touched.coordinateName && errors.coordinateName ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.coordinateName}
                                                </span> : null
                                            }
                                            {touched.coordinatePhone && errors.coordinatePhone ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.coordinatePhone}
                                                </span> : null
                                            }
                                            {touched.coordinateMobile && errors.coordinateMobile ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.coordinateMobile}
                                                </span> : null
                                            }
                                            {touched.coordinateEmail && errors.coordinateEmail ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.coordinateEmail}
                                                </span> : null
                                            } */}
                                        </Label>
                                        <Col>
                                            <Input
                                                className={touched.coordinateName && errors.coordinateName ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="coordinateName"
                                                id="coordinateName"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={values?.coordinateName}
                                            // disabled
                                            />

                                        </Col>
                                        <div className="px-3 pt-4">
                                            <FormGroup row>
                                                <Label
                                                    for="coordinatePhone"
                                                    sm={2}
                                                >
                                                    โทรศัพท์
                                                    <span
                                                        className="require-input">
                                                        *
                                                    </span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinatePhone"
                                                        name="coordinatePhone"
                                                        type="text"
                                                        className={touched.coordinatePhone && errors.coordinatePhone ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinatePhone}
                                                    // disabled
                                                    />
                                                </Col>

                                                <Label
                                                    for="coordinateMobile"
                                                    sm={2}
                                                >
                                                    โทรศัพท์มือถือ
                                                    <span
                                                        className="require-input">
                                                        *
                                                    </span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateMobile"
                                                        name="coordinateMobile"
                                                        type="text"
                                                        className={touched.coordinateMobile && errors.coordinateMobile ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinateMobile}
                                                    // disabled
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label
                                                    for="soi"
                                                    sm={2}
                                                >
                                                    โทรสาร
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateFax"
                                                        name="coordinateFax"
                                                        type="text"
                                                        className={touched.coordinateFax && errors.coordinateFax ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinateFax}
                                                    // disabled
                                                    />
                                                </Col>

                                                <Label
                                                    for="coordinateEmail"
                                                    sm={2}
                                                >
                                                    อีเมล
                                                    <span
                                                        className="require-input">
                                                        *
                                                    </span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateEmail"
                                                        name="coordinateEmail"
                                                        type="text"
                                                        className={touched.coordinateEmail && errors.coordinateEmail ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinateEmail}
                                                    // disabled
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        {dataAnnounce6?.map((item, i) => (
                                            <FormGroup key={i}>
                                                <Label className="mb-2 input-color" style={{ fontWeight: "bold" }}>
                                                    2. รายละเอียดการดำเนินการพัฒนาฝีมือแรงงาน
                                                </Label>

                                                <p className="type-register">ในปี พ.ศ. {item.receiveYear} (ปีที่ผ่านมา) มีลูกจ้างเฉลี่ยรวมทั้งสิ้น จำนวน <span className="mx-1">{item.avgMan}</span> คน</p>
                                                <p className="type-register">ได้ดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้าง จำนวน  <span className="mx-1">{item.spkTrainMan} คน</span> คิดเป็นร้อยละ <span className="mx-1">{item.trainPercent}</span> ของลูกจ้างทั้งหมด (ไม่ซ้ำคน) ดังนี้ </p>
                                                <div className="px-1">
                                                    <ul>
                                                        <li>
                                                            <div className="d-flex justify-content-start">
                                                                <span className="type-register">จัดให้มีการฝึกอบรมฝีมือแรงงาน จำนวน</span>
                                                                <span className="type-register mx-1">{item.train ? item.train : "-"} คน</span>
                                                            </div>

                                                        </li>
                                                        <li>
                                                            <div className="d-flex justify-content-start">
                                                                <span className="type-register">ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ จำนวน</span>
                                                                <span className="type-register mx-1">{item.test ? item.test : "-"} คน</span>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="d-flex justify-content-start">
                                                                <span className="type-register">ผ่านการรับรองความรู้ความสามารถ จำนวน</span>
                                                                <span className="type-register mx-1">{item.oloc ? item.oloc : "-"} คน</span>
                                                            </div>

                                                        </li>
                                                    </ul>
                                                </div>
                                            </FormGroup>
                                        ))}

                                    </FormGroup>
                                    {/* =========================
{/* ====== SECTION 3: การคำนวณเงินช่วยเหลืออุดหนุน (JavaScript) ====== */}
                                    {(() => {
                                        // Helpers
                                        const N = v => Number(v ?? 0);
                                        const INT = v => Math.max(0, Math.floor(Number(v ?? 0)));
                                        const money = v => NumberWithCommas(v ?? 0);

                                        // ใช้เรคอร์ดแรกของผลตรวจสิทธิ์
                                        const a6 = (dataAnnounce6 && dataAnnounce6[0]) || {};

                                        // ค่าพื้นฐาน
                                        const avgMan = N(a6?.avgMan);         // ลูกจ้างเฉลี่ย
                                        // console.log("avgMan", avgMan);

                                        const avg70 = INT(a6?.avg70);        // 70% (มีมาจาก backend)
                                        // console.log("avg70", avg70);

                                        // const avg80 = INT(avgMan * 0.8);    // 80% ของลูกจ้างเฉลี่ย
                                        const avg80 = Math.ceil(avgMan * 0.8);    // 80% ของลูกจ้างเฉลี่ย ปัดขึ้นเป็นจำนวนเต็ม
                                        // console.log("avg80", avg80);
                                        // console.log("avg70", avg70);
                                        const trainedTotal = a6.trainPercent > 100 ? avgMan : INT(a6?.spkTrainMan);  // จำนวนผู้พัฒนาฝีมือ "ทั้งหมด"
                                        // console.log("trainedTotal", trainedTotal);

                                        // ขั้นที่ 1: ช่วง 70–80%
                                        // const step1Count = Math.max(0, avg80 - avg70);
                                        const step1Count = a6?.cntGt70Lt80;
                                        // console.log("step1Count", step1Count);

                                        const step1Rate = 200;
                                        const step1Amount = a6?.amt70;
                                        // console.log("step1Amount", step1Amount);

                                        // ขั้นที่ 2: เกิน 80–100% (ไม่เกิน 100% = avgMan)
                                        const step2Count = trainedTotal - avg80;
                                        // console.log("step2Count", step2Count);
                                        const step2Rate = 300;
                                        const step2Amount = a6?.amt80;
                                        // console.log("step2Amount", step2Amount);

                                        // รวม
                                        const totalAmount = step1Amount + step2Amount;
                                        // console.log("totalAmount", totalAmount);
                                        setCalculateAmount(totalAmount);
                                        return (
                                            <FormGroup className="mt-4">
                                                <Label className="mb-2 input-color" style={{ fontWeight: "bold" }}>
                                                    3. การคำนวณเงินช่วยเหลืออุดหนุน
                                                </Label>

                                                {/* ขั้นที่ 1 */}
                                                <div className="px-2">
                                                    <p style={{ fontWeight: 600 }}>
                                                        ขั้นที่ 1: ในส่วนที่เกินกว่าร้อยละ 70 แต่ไม่เกินร้อยละ 80 ของลูกจ้างเฉลี่ย
                                                    </p>
                                                    <ul className="type-register">
                                                        <li>
                                                            3.1 จำนวนลูกจ้างที่ดำเนินการพัฒนาฝีมือแรงงานร้อยละ 70 =
                                                            <span className="mx-1">{avg70}</span> คน
                                                        </li>
                                                        <li>
                                                            3.2 จำนวนลูกจ้างที่ดำเนินการพัฒนาฝีมือแรงงานร้อยละ 80 =
                                                            <span className="mx-1">{avg80}</span> คน
                                                        </li>
                                                        <li>
                                                            3.3 จำนวนลูกจ้างช่วง 70–80% =
                                                            <span className="mx-1">{step1Count}</span> คน
                                                        </li>
                                                        <li>
                                                            3.4 อัตราเงินช่วยเหลือฯ ส่วน 70–80 =
                                                            <span className="mx-1">{step1Rate}</span> บาท/คน
                                                        </li>
                                                        <li>
                                                            3.5 เงินช่วยเหลือขั้นที่ 1 (ข้อ 3.3 × {step1Rate}) =
                                                            <span className="mx-1">{money(step1Amount)}</span> บาท
                                                        </li>
                                                    </ul>
                                                </div>

                                                {/* ขั้นที่ 2 */}
                                                <div className="px-2 mt-3">
                                                    <p style={{ fontWeight: 600 }}>
                                                        ขั้นที่ 2: ในส่วนที่เกินกว่าร้อยละ 80 แต่ไม่เกินร้อยละ 100 ของลูกจ้างเฉลี่ย
                                                    </p>
                                                    <ul className="type-register">
                                                        <li>
                                                            3.6 จำนวนลูกจ้างที่พัฒนาฝีมือทั้งหมด =
                                                            <span className="mx-1">{trainedTotal}</span> คน
                                                        </li>
                                                        <li>
                                                            3.7 ร้อยละ 80 ของลูกจ้างเฉลี่ย (ตามข้อ 3.2) =
                                                            <span className="mx-1">{avg80}</span> คน
                                                        </li>
                                                        <li>
                                                            3.8 จำนวนที่เกิน 80–100% =
                                                            <span className="mx-1">{step2Count < 0 ? 0 : step2Count}</span> คน
                                                        </li>
                                                        <li>
                                                            3.9 อัตราเงินช่วยเหลือฯ ส่วน 80–100 =
                                                            <span className="mx-1">{step2Rate}</span> บาท/คน
                                                        </li>
                                                        <li>
                                                            3.10 เงินช่วยเหลือขั้นที่ 2 (ข้อ 3.8 × {step2Rate}) =
                                                            <span className="mx-1">{money(step2Amount)}</span> บาท
                                                        </li>
                                                    </ul>
                                                </div>

                                                {/* รวม */}
                                                <div className="px-2 mt-3">
                                                    <p className="type-register" style={{ fontWeight: 600 }}>
                                                        ทั้งหมด คิดเป็นจำนวนเงินรวม (ข้อ 3.5 + ข้อ 3.10) =
                                                        <span className="mx-1">{money(totalAmount)}</span> บาท
                                                    </p>
                                                </div>
                                            </FormGroup>
                                        );
                                    })()}


                                    {/* <FormGroup>
                                        {dataAnnounce6?.map((item, i) => (
                                            <FormGroup key={i}>
                                                <p className="type-register">ในปี พ.ศ. {item.receiveYear} (ปีที่ผ่านมา) มีลูกจ้างเฉลี่ยรวมทั้งสิ้น จำนวน <span className="mx-1">{item.avgMan}</span> คน</p>
                                                <p className="type-register">ได้ดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้าง จำนวน  <span className="mx-1">{item.spkTrainMan} คน</span> คิดเป็นร้อยละ <span className="mx-1">{item.perc}</span> ของลูกจ้างทั้งหมด (ไม่ซ้ำคน) ดังนี้ </p>
                                                <div className="px-1">
                                                    <ul>
                                                        <li>
                                                            <div className="d-flex justify-content-start">
                                                                <span className="type-register">จัดให้มีการฝึกอบรมฝีมือแรงงาน จำนวน</span>
                                                                <span className="type-register mx-1">{item.train ? item.train : "-"} คน</span>
                                                            </div>

                                                        </li>
                                                        <li>
                                                            <div className="d-flex justify-content-start">
                                                                <span className="type-register">ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ จำนวน</span>
                                                                <span className="type-register mx-1">{item.test ? item.test : "-"} คน</span>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="d-flex justify-content-start">
                                                                <span className="type-register">ผ่านการรับรองความรู้ความสามารถ จำนวน</span>
                                                                <span className="type-register mx-1">{item.oloc ? item.oloc : "-"} คน</span>
                                                            </div>

                                                        </li>
                                                    </ul>
                                                </div>
                                            </FormGroup>
                                        ))}

                                    </FormGroup> */}
                                    {/* ความประสงค์ขอรับเงิน */}
                                    <FormGroup className='mt-3'>
                                        <Label>
                                            มีความประสงค์ขอรับเงินช่วยเหลืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545 เป็นจำนวนเงินทั้งสิ้น
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.amount && errors.amount ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.amount}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        {!calculateLoading ? (
                                            <Input
                                                id="amount"
                                                name="amount"
                                                type="text"
                                                disabled={true}
                                                className={touched.amount && errors.amount ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={NumberWithCommas(calculateAmount ?? "0")}

                                            />
                                        ) : (
                                            <></>
                                        )}


                                        {/* <p></p> */}
                                        {/* {NumberWithCommas(calculateAmount)} */}
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>
                                            โดยขอรับเช็คขีดคร่อมสั่งจ่ายในนาม
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.paymentName && errors.paymentName ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.paymentName}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Input
                                            id="paymentName"
                                            name="paymentName"
                                            type="text"
                                            className={touched.paymentName && errors.paymentName ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values?.paymentName}

                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>
                                            เอกสารอื่นๆ (ถ้ามี)
                                            {touched.fOtherPath && errors.fOtherPath ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.fOtherPath}
                                                </span> : null
                                            }
                                            {currentSupportForm?.fOtherPathView != null ? (
                                                <FaSistrix
                                                    className="mx-3 style-icon"
                                                    onClick={() => window.open(currentSupportForm?.fOtherPathView)}
                                                />
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="fOtherPath"
                                            name="fOtherPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                const maxSize = 25 * 1024 * 1024; // 5MB in bytes

                                                if (file) {
                                                    if (file.size > maxSize) {
                                                        Swal.fire({
                                                            icon: "warning",
                                                            title: "ขนาดไฟล์เกิน 25MB",
                                                            allowOutsideClick: false,
                                                            allowEscapeKey: false,
                                                            text: "กรุณาเลือกไฟล์ขนาดไม่เกิน 25MB",
                                                            confirmButtonColor: "#0A66C2",
                                                            confirmButtonText: "ตกลง",
                                                        })
                                                        // alert("File size exceeds 5MB. Please select a smaller file.");
                                                        e.target.value = ""; // Reset file input
                                                        return;
                                                    }
                                                    setFieldValue("fOtherPath", file);
                                                }
                                            }}
                                        // onChange={(e) => {
                                        //     setFieldValue(`fOtherPath`, e.target.files[0]);
                                        // }}
                                        />
                                    </FormGroup>

                                    {/* term */}
                                    <div className='d-flex'>
                                        <Input
                                            type="checkbox"
                                            invalid={errors.term ? true : false}
                                            name="term"
                                            id="term"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values?.term}
                                            checked={values?.term}
                                        />
                                        <Label
                                            for="term"
                                            className='mx-2 customer-type'
                                        >
                                            ข้าพเจ้ารับรองว่าข้อความดังกล่าวข้างต้นและเอกสารหลักฐานที่แนบคำขอถูกต้องและเป็นความจริงทุกประการ
                                        </Label>

                                    </div>

                                    <div className='d-flex justify-content-center align-items-center mt-5'>
                                        <button
                                            type="submit"
                                            disabled={values?.term ? false : true}
                                            // disabled={!isValid}
                                            className='btn-blue px-4 w-25'
                                        >
                                            ส่งคำขอ
                                        </button>
                                    </div>

                                </Form>
                            </div>

                        ) : (
                            <Loading />
                        )}


                    </Container>


                )
            }}



        </Formik>

    );

}
